"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import ResourceGridTab from "./ResourceGridTab";
import { layoutEyebrowClasses, layoutHeaderClasses, layoutHeaderBigClasses } from "@/components/tailwindHelpers";

// export interface blogCard {
//   eyebrow?: string;
//   header: string;
//   date: string;
//   image: {
//     url: string;
//     alt: string;
//     height: number;
//     width: number;
//     x: number;
//     y: number;
//     title: string;
//   };
//   destination?: string;
//   description: string;
//   button?: {
//     destination: string;
//     label: string;
//   };
//   tabLabel?: string; // Label that determines which tab the card belongs to
//   tags?: string[]; // Tags for filtering
// }

export interface ResourceGridProps {
  id?: string;
  eyebrow?: string;
  header?: string;
  subheader?: string;
  description?: any;
  headerElement?: "h1" | "h2";
  tabsList: any;
  allResourceCards?: any[];
  config?: any;
  loadMoreText?: string;
  onLoadMore?: () => void;
  presetTheme?: "t2-theme-one" | "t2-theme-two" | "t2-theme-three" | "t2-theme-four" | "t2-theme-five" | "t2-theme-six" | "t2-theme-seven";
  isHeaderBig?: boolean;
  isWrapped?: boolean;
  isHeaderH1?: boolean;
  previewEnabled?: boolean;
  lang?: string;
  cardDisplayMode?: "AND" | "OR";
}
export const TabbedResourceGrid = t0 => {
  const $ = _c(28);
  const {
    id,
    eyebrow,
    header,
    headerElement: t1,
    tabsList,
    allResourceCards,
    config,
    isHeaderBig,
    isHeaderH1: t2,
    presetTheme,
    lang,
    cardDisplayMode
  } = t0;
  t1 === undefined ? "h2" : t1;
  const isHeaderH1 = t2 === undefined ? false : t2;
  const [activeTab, setActiveTab] = useState(0);
  const headerClasses = isHeaderBig ? layoutHeaderBigClasses : layoutHeaderClasses;
  const mainClasses = `${presetTheme || ""} w-full px-5 lg:px-20 m-auto max-w-[1440px] pt-10 pb-[90px] max-sm:pt-[50px]`;
  const formatTabFilters = _temp3;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = index => {
      setActiveTab(index);
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const handleTabClick = t3;
  const t4 = `t2-resource-grid ${mainClasses}`;
  let t5;
  if ($[1] !== eyebrow || $[2] !== header || $[3] !== headerClasses || $[4] !== isHeaderH1) {
    t5 = (eyebrow || header) && <div className="mb-20 max-sm:mb-[50px]">{eyebrow && <div className={layoutEyebrowClasses}>{eyebrow}</div>}{header && !isHeaderH1 && <h2 className={headerClasses}>{header}</h2>}{header && isHeaderH1 && <h1 className={headerClasses}>{header}</h1>}</div>;
    $[1] = eyebrow;
    $[2] = header;
    $[3] = headerClasses;
    $[4] = isHeaderH1;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== activeTab || $[7] !== id || $[8] !== tabsList) {
    t6 = tabsList?.map((tab_0, index_0) => {
      const isActive = index_0 === activeTab;
      return <button key={index_0} type="button" role="tab" data-tab-role="tab" aria-selected={isActive} aria-controls={`rg-tabpanel-${id}-${index_0}`} tabIndex={isActive ? 0 : -1} className={`${"text-base leading-[22px] tracking-[0.4px] text-gray-m9 px-[25px] pt-[10px] pb-[15px] font-normal uppercase m-0 cursor-pointer max-sm:px-5 max-sm:py-2.5 max-sm:whitespace-nowrap max-sm:border-b-4 max-sm:border-b-transparent"}${isActive ? " shadow-[0_-2px_6px_rgba(0,0,0,0.08)] border-b-4 border-b-blue-trmb font-bold !text-blue-trmb bg-transparent" : ""} border-0 bg-transparent`} onClick={() => handleTabClick(index_0)}>{tab_0?.displayName}</button>;
    });
    $[6] = activeTab;
    $[7] = id;
    $[8] = tabsList;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = <div role="tablist" className="flex flex-col sm:flex-row border-b border-[#e0e1e9] mb-[31px] max-sm:mb-[50px]">{t6}</div>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== activeTab || $[13] !== allResourceCards || $[14] !== cardDisplayMode || $[15] !== config || $[16] !== id || $[17] !== lang || $[18] !== tabsList) {
    t8 = tabsList?.map((tab_1, index_1) => {
      const mainTabCardFilters = tab_1?.filterContentByTagsCollection?.items?.map(_temp4);
      return <div key={index_1} id={`rg-tabpanel-${id}-${index_1}`} role="tabpanel" className="resource-grid__tab-panel" hidden={index_1 !== activeTab}><ResourceGridTab id={tab_1?.sys?.id} index={index_1} displayName={tab_1?.displayName} filters={formatTabFilters(tab_1)} activeTab={activeTab} typeToGather={tab_1?.typeToGather} cardDisplayMode={cardDisplayMode} mainCardFilters={mainTabCardFilters} config={config} allCards={allResourceCards} lang={lang} /></div>;
    });
    $[12] = activeTab;
    $[13] = allResourceCards;
    $[14] = cardDisplayMode;
    $[15] = config;
    $[16] = id;
    $[17] = lang;
    $[18] = tabsList;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== id || $[21] !== t7 || $[22] !== t8) {
    t9 = <div id={id} className="min-h-[700px] max-lg:px-5 max-lg:w-full max-lg:overflow-hidden">{t7}{t8}</div>;
    $[20] = id;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t4 || $[25] !== t5 || $[26] !== t9) {
    t10 = <div className={t4}>{t5}{t9}</div>;
    $[24] = t4;
    $[25] = t5;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
};
function _temp(tag_0) {
  return {
    label: tag_0?.displayName,
    id: tag_0?.sys?.id
  };
}
function _temp2(tag) {
  const newValues = tag?.tagSectionCollection?.items?.map(_temp);
  return {
    id: tag?.sys?.id,
    title: tag?.displayName,
    dropdownValues: newValues
  };
}
function _temp3(tab) {
  const filterTags = tab?.filterByTagsCollection?.items?.map(_temp2);
  return {
    filterTags
  };
}
function _temp4(tag_1) {
  return {
    title: tag_1?.displayName,
    id: tag_1?.sys?.id
  };
}